/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    young<yangyang@frippler.com>
  | @Title:     设备-授权 API
  | @Version:   2019-02-18  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'
const Rms_host = process.env.VUE_APP_RMS_API_HOST;

export function updateEquipUserAuthApi(equipid, uid, auth) {
  return request({
    url: '?c=rms&a=equip-binder&do=auth',
    method: 'get',
    params: {
      equipid,
      userid: uid,
      type: 'user_auth',
      value: auth
    }
  })
}

export function updateEquipMemberAuthApi(equipid, memberid, auth) {
  return request({
    url: '?c=rms&a=equip-binder&do=auth',
    method: 'get',
    params: {
      equipid,
      userid: memberid,
      type: 'member_auth',
      value: auth
    }
  })
}

export function updateEquipMemberAuthApi2(data) {
  return request({
    url: `${Rms_host}/binder/auth`,
    method: 'post',
    data
  })
}

export function updateEquipUserBlacklistApi(equipid, uid, blacklist) {
  return request({
    url: '?c=rms&a=equip-binder&do=auth',
    method: 'get',
    params: {
      equipid,
      userid: uid,
      type: 'user_blacklist',
      value: blacklist ? 1 : 0
    }
  })
}

export function updateEquipMemberBlacklistApi(equipid, memberid, blacklist) {
  return request({
    url: '?c=rms&a=equip-binder&do=auth',
    method: 'get',
    params: {
      equipid,
      userid: memberid,
      type: 'member_blacklist',
      value: blacklist ? 1 : 0
    }
  })
}
